import { render, staticRenderFns } from "./companiesHome.vue?vue&type=template&id=55f6c512&scoped=true"
import script from "./companiesHome.vue?vue&type=script&lang=js"
export * from "./companiesHome.vue?vue&type=script&lang=js"
import style0 from "./companiesHome.vue?vue&type=style&index=0&id=55f6c512&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f6c512",
  null
  
)

export default component.exports